import { Routes } from '@angular/router';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { LoginComponent } from './pages/login/login.component';
import { RequestPasswordResetComponent } from './pages/forgot-password/request-password-reset/request-password-reset.component';
import { MailSentComponent } from './pages/forgot-password/mail-sent/mail-sent.component';
import { ResetPasswordComponent } from './pages/forgot-password/reset-password/reset-password.component';
import { VerifyEmailComponent } from './pages/verify-email/verify-email.component';
import { ConfirmEmailChangeComponent } from './pages/confirm-email-change/confirm-email-change.component';
import { AcceptInvitationComponent } from './pages/invitation/accept-invitation.component';
import { InvalidInvitationComponent } from './pages/invalid-invitation/invalid-invitation.component';

export const AUTH_ROUTES: Routes = [
  {
    path: '',
    providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'auth' }],
    children: [
      {
        path: '',
        redirectTo: 'start',
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent,
        pathMatch: 'full'
      },
      {
        path: 'register',
        loadChildren: () => import('./pages/register/register.routes').then((m) => m.REGISTER_ROUTES)
      },
      {
        path: 'forgot-password',
        component: RequestPasswordResetComponent,
        pathMatch: 'full'
      },
      {
        path: 'forgot-password/mail-sent',
        component: MailSentComponent,
        pathMatch: 'full'
      },
      {
        path: 'passwordReset/:tokenAndEmail',
        component: ResetPasswordComponent,
        pathMatch: 'full'
      },
      {
        path: 'verifyEmail/:token',
        component: VerifyEmailComponent,
        pathMatch: 'full'
      },
      {
        path: 'confirmEmailChange/:token',
        component: ConfirmEmailChangeComponent,
        pathMatch: 'full'
      },
      {
        path: 'invitation/accept/:token',
        component: AcceptInvitationComponent,
        pathMatch: 'full'
      },
      {
        path: 'invitation/invalid',
        component: InvalidInvitationComponent,
        pathMatch: 'full'
      }
    ]
  }
];
